// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CustomizableList_contentComponent__21CdC","tableContainer":"CustomizableList_tableContainer__pFRVQ"};